import { useMutation } from '@tanstack/react-query'
import { createHelp } from '../index'

const useCreateHelp = () => {
  return useMutation({
    mutationFn: createHelp,
  })
}

export default useCreateHelp
